import React from 'react';
import HODWaiverAppr from './HODWaiverApproval';
import '../../../CommonCSS/SocietyCSS.css'

const HODWaiverApprApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>HOD Fee Waiver Approval</h5>
          </div>  
        </div>
        <HODWaiverAppr/>
      </div>
    </div >
  );
};

export default HODWaiverApprApp;
